import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import autoBind from "react-autobind";
import shadowRoot from "react-shadow";
import TimelineActivity from "~/components/drawers/timeline/activity";
import ActivityEditor from "~/components/forms/HtmlEditors/ActivityEditor";
import dayjs from "~/lib/dayjs";

class TimelineActivityRetention extends TimelineActivity {
  constructor(props) {
    super(props);

    const { activity } = this.props;

    autoBind(this);
  }

  renderView() {
    const { activity } = this.state;

    return (
      <div>
        <p className="text-grey mb5">
          on {dayjs(activity.occurred_at).format("dddd, MMMM Do YYYY, h:mm a")}
        </p>

        {activity.body && (
          <shadowRoot.div className="form-control font-activity">
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: activity.body || "" }}
            />
          </shadowRoot.div>
        )}
      </div>
    );
  }

  renderForm() {
    const { activity } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <ActivityEditor
          value={activity.body}
          onChange={(html) => {
            this.setState((prevState) => ({
              queuedChanges: { ...prevState.queuedChanges, body: html },
            }));
          }}
          placeholder="Enter Text"
          activityType="note"
          leadId={this.state.lead?.id}
        />
        <div className="mt5">
          <button
            type="submit"
            className="btn btn-primary btn-sm mr5"
            disabled={this.state.sending}
          >
            {this.state.sending ? (
              <span>
                <FontAwesomeIcon icon="far fa-spinner" pulse className="mr5" />{" "}
                Saving
              </span>
            ) : (
              "Save"
            )}
          </button>
          <a
            href="#"
            onClick={() => {
              this.setState({ queuedChanges: {}, editing: false });
            }}
            className="btn btn-secondary btn-sm"
          >
            Cancel
          </a>
        </div>
        {this.renderUnsupportedVariablesWarning()}
      </form>
    );
  }
}

TimelineActivityRetention.defaultProps = {
  editable: true,
  deletable: true,
  title: "Retention Logged",
  icon: "list-alt",
  prefix: "far",
  color: "text-blue",
  alwaysPublic: false,
};

export default TimelineActivityRetention;
